const GriData = ({ data }) => {
    return (
        <>
            {
                data.map((curData => {
                    const { id, name, year, category, source, supplier, location, ground_water, surface_water, sea_water, third_party, produced, muncipal_solid_waste, non_hazardous_waste, hazardous_waste, used_oil, wood_waste, metal_waste, e_waste, universal_waste, description, total_employee, overall_turnover_rate, new_employee, unit, total } = curData;

                    return (
                        <tr key={id}>
                            <td >{name}</td>
                            <td >{year}</td>
                            <td >{category}</td>
                            <td >{source}</td>
                            <td >{supplier}</td>
                            <td >{location}</td>
                            <td >{ground_water}</td>
                            <td >{surface_water}</td>
                            <td >{sea_water}</td>
                            <td >{third_party}</td>
                            <td >{produced}</td>
                            <td >{muncipal_solid_waste}</td>
                            <td >{non_hazardous_waste}</td>
                            <td >{hazardous_waste}</td>
                            <td >{used_oil}</td>
                            <td >{wood_waste}</td>
                            <td >{metal_waste}</td>
                            <td >{e_waste}</td>
                            <td >{universal_waste}</td>
                            <td >{description}</td>
                            <td >{total_employee}</td>
                            <td >{overall_turnover_rate}</td>
                            <td >{new_employee}</td>
                            <td >{unit}</td>
                            <td >{total}</td>
                        </tr>
                    )
                }))
            }
        </>
    )
}

export default GriData;